import React from "react";
import SelectionLayer from "./selection-layer/SelectionLayer";

export default function GlobalLayers({
	pdfContainerRef,
	selectionRectangleRef,
	start,
	end,
	onCloseAddRedressment,
	onCloseSelection,
}) {
	return (
		<SelectionLayer
			end={end}
			pdfContainerRef={pdfContainerRef}
			selectionRectangleRef={selectionRectangleRef}
			start={start}
			onCloseAddRedressment={onCloseAddRedressment}
			onCloseSelection={onCloseSelection}
		/>
	);
}
